// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__iypij","title":"ClientInsurance_title__2y1JZ","itemText":"ClientInsurance_itemText__wYBHl"};